export const colorPickerEn = {
  columnColor: 'Column color',
  taskColumnColor: 'Task color'
}

export const colorPickerRu: typeof colorPickerEn = {
  columnColor: 'Цвет колонки',
  taskColumnColor: 'Цвет задачи'
}
